import { Trans, useTranslation } from 'react-i18next';
import { Sun, Droplet, Shield, type LucideIcon } from 'lucide-react';

type Pillar = {
  key: 'reliability' | 'comfort' | 'security';
  Icon: LucideIcon;
};

const PILLARS: Pillar[] = [
  { key: 'reliability', Icon: Sun },
  { key: 'comfort', Icon: Droplet },
  { key: 'security', Icon: Shield },
];

export default function Principles() {
  const { t } = useTranslation();

  return (
    <section
      id="principles"
      className="border-y border-line bg-surface px-6 py-20 md:px-10 md:py-24"
    >
      <header className="mb-12 max-w-[760px]">
        <div className="mb-3 text-xs uppercase tracking-[0.12em] text-accent">
          ❋&nbsp;&nbsp;{t('principles.eyebrow')}
        </div>
        <h2 className="m-0 text-balance font-display font-semibold leading-[1.05] tracking-display text-ink [font-size:clamp(36px,4.4vw,60px)]">
          <Trans i18nKey="principles.headline" components={{ break: <br /> }} />
        </h2>
      </header>
      <div className="grid grid-cols-1 gap-6 md:grid-cols-3 md:gap-8">
        {PILLARS.map(({ key, Icon }) => (
          <article key={key} className="rounded-md border border-line bg-bg p-6 md:p-7">
            <div className="mb-5 inline-flex h-11 w-11 items-center justify-center rounded-full bg-accent/10 text-accent">
              <Icon size={20} aria-hidden />
            </div>
            <h3 className="m-0 font-display text-[20px] font-semibold tracking-display text-ink">
              {t(`principles.${key}.title`)}
            </h3>
            <p className="mt-3 text-pretty text-[15px] leading-relaxed text-muted">
              {t(`principles.${key}.body`)}
            </p>
          </article>
        ))}
      </div>
    </section>
  );
}
